/* eslint-disable no-param-reassign */
// @deprecated
// Этот файл надо растащить на методы и переместить поближе к тем местам, где они используются
// Методы, использующиеся в 2+ файлах переложить в src/shared/utils

// Меняет местами широту и долготу, косяк на бэке
export function swapLatLng(coordinates) {
  [coordinates.lat, coordinates.lng] = [coordinates.lng, coordinates.lat];
}

export const camelToDash = str => {
  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
};

// get object property by name
export const getProperty = (o, s) => {
  s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  s = s.replace(/^\./, ''); // strip a leading dot
  var a = s.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (k in o) {
      o = o[k];
    } else {
      return;
    }
  }

  return o;
};

// set object property by name
export const setProperty = (o, s, v) => {
  s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  s = s.replace(/^\./, ''); // strip a leading dot
  var a = s.split('.');
  for (var i = 0, n = a.length; i < n - 1; ++i) {
    var k = a[i];
    if (k in o) {
      o = o[k];
    } else {
      o = o[k] = {};
    }
  }
  o[a[a.length - 1]] = v;
};

// delete object property by name
export const deleteProperty = (o, s) => {
  s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  s = s.replace(/^\./, ''); // strip a leading dot
  var parts = s.split('.');
  for (var i = 0, n = parts.length; i < n - 1; ++i) {
    var k = parts[i];
    if (k in o) {
      o = o[k];
    } else {
      return;
    }
  }
  o[parts[parts.length - 1]] = undefined;
};

// remove item from array by value
export function removeFromArray(array, value) {
  var index = array.indexOf(value);
  if (index !== -1) {
    array.splice(index, 1);
  }
}

/**
 * Проверить является ли value корректным значением перечисления items
 * @param items список всех элементов перечисления (массив объектов вида { key: 'wood', name: 'Деревянный' }
 * @param value проверяемое значение, например 'wood'
 * @param itemValueProperty имя свойства со значением внутри каждого элемента
 * @returns {boolean}
 */
export const isValidEnum = (items, value, itemValueProperty = 'key') => {
  return !!items.find(i => i[itemValueProperty] === value);
};

/**
 * Парсит query string параметры
 * @returns {{}}
 */
export const getSearchParams = () => {
  return (window.location.search || ' ')
    .substring(1)
    .split('&')
    .reduce((result, param) => {
      const tuple = param.split('=');
      if (tuple[0]) {
        result[tuple[0]] = tuple[1];
      }

      return result;
    }, {});
};

export const formatPhone = function (phone) {
  return phone.countryCode === '+7'
    ? `${phone.countryCode} ${phone.number.replace(/^(\d+)(\d\d\d)(\d\d)(\d\d)$/, '$1 $2-$3-$4')}`
    : `${phone.countryCode} ${phone.number}`;
};
